// extracted by mini-css-extract-plugin
module.exports = {"links":"links-37Z-7","category":"category-Xo1eg","title":"title-D35cr","linkItem":"linkItem-AJmtP","newTagWrapper":"newTagWrapper-NRy-G"};